import { css } from '@/styled-system/css';

export const drawerCloseButtonStyles = css.raw({
  insetBlockStart: 'tighter',
  insetInlineEnd: 'tighter',
  position: 'absolute',
  zIndex: 100,
});
